import { Component, Inject, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, Scroll } from '@angular/router';
import { ShopApiService } from './services/shop-api.service';
import { Shop } from './interfaces/shop.interface';
import { ShopService } from './services/shop.service';
import { AuthAPIService } from './services/auth-api.service';
import { CanDeactivate } from './can-deactivate/can-deactivate';
import { Title, Meta } from '@angular/platform-browser';
import { TranslocoService } from '@ngneat/transloco';
import { UserSessionService } from './services/user-session.service';
import { isPlatformBrowser } from '@angular/common';
import { filter, map, Observable, Subject } from 'rxjs';
import { AuthService } from './services/auth.service';
import { isUserVerified } from '../utils/isUserVerified';
import { isUserMissingData } from '../utils/isUserMissingData';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.components.scss'],
})
export class HomeComponent extends CanDeactivate implements OnInit, OnDestroy {
  nameShop: string;
  shop: Shop;
  summaryView$: Observable<boolean>;
  destroy$ = new Subject();
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    protected shopApiService: ShopApiService,
    protected shopService: ShopService,
    private authApiService: AuthAPIService,
    private userSessionService: UserSessionService,
    private titleService: Title,
    private meta: Meta,
    private translateService: TranslocoService,
    @Inject(PLATFORM_ID) private platformId: Object,
    private authService: AuthService
  ) {
    super(shopApiService, shopService);

    this.shopService.facebookRedirect = undefined;
    this.shopService.paymentRedirect = undefined;
    this.shopService.summaryPage = undefined;
    this.shopService.appicRedirect = undefined;
  }

  ngOnInit(): void {
    this.summaryView$ = this.router.events.pipe(
      filter((routerEvents) => {
        return (routerEvents as Scroll).routerEvent instanceof NavigationEnd;
      }),
      map((routerEvents) => {
        return (routerEvents as Scroll).routerEvent.url.includes('/summary');
      })
    );

    if (this.userSessionService.disableGetProfileInit) {
      this.userSessionService.disableGetProfileInit = false;
    } else {
      this.userSessionService.getProfile().subscribe((user) => {
        if (user) {
          const userEnteredDataManuallyDuckTyping = !user.profile;
          if (!userEnteredDataManuallyDuckTyping) {
            if (
              (isUserMissingData(user) || !isUserVerified(user)) &&
              isPlatformBrowser(this.platformId) &&
              !this.router.url.includes('summary?order')
            ) {
              this.authService.logOut(this.logOutCb.bind(this));
            }
          }
        }
      });
    }

    this.route.queryParams.subscribe((params) => {
      if (params['source'] || params['campaign']) {
        let source: string = params['source'];
        let campaign: string = params['campaign'];

        if (source) {
          if (source.length > 255) {
            source = source.substring(0, 255);
          }
          this.shopService.source = source;
        }

        if (campaign) {
          if (campaign.length > 255) {
            campaign = campaign.substring(0, 255);
          }
          this.shopService.campaign = campaign;
        }
      }
    });

    this.route.params.subscribe((params) => {
      this.nameShop = params['name'];
      const source = this.shopService.source;
      const campaign = this.shopService.campaign;
      this.shopApiService.getShop(this.nameShop, source, campaign).subscribe(
        (response: Shop) => {
          this.shop = this.shopService.shop = response;

          if (this.shop.uuid === this.nameShop) {
            if (isPlatformBrowser(this.platformId)) {
              window.location.href =
                '/redirect/' +
                this.shop.uuid +
                '?' +
                this.encodeQueryData(this.shopService.getQueryParams({ campaign: this.shopService.campaign }));
            }
          }

          this.setMetaDescription(this.shop.name);
          this.titleService.setTitle(this.shop.name + ' - Tickets');
          /*  if (this.shop.status === 'expired') {
            this.router.navigate(['expired'], {
              relativeTo: this.route,
            });
          } else if (this.shop.status === 'upcoming') {
            this.router.navigate(['upcoming'], {
              relativeTo: this.route,
            });
          } else if (this.shop.status === 'active' && !this.route.children.length) {
            this.router.navigate(['tickets'], {
              relativeTo: this.route,
            });
          } */
        },
        (error: any) => {
          if (error.status === 404) {
            this.router.navigate(['notfound'], {});
          }
        }
      );
    });
  }
  logOutCb() {
    if (!this.shopService?.shop?.url_extension) {
      this.router.navigate([]);
    } else if (this.shopService.shop.url_extension) {
      this.router.navigate([this.shopService.shop.url_extension, 'tickets']);
    } else {
      this.router.navigate([]);
    }
  }
  canCloseTab(): boolean {
    if (this.shopService.shoppingCart) {
      if (
        this.shopService.appicRedirect ||
        this.shopService.facebookRedirect ||
        this.shopService.paymentRedirect ||
        this.shopService.summaryPage
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }

  isTooLight(colorHex): boolean {
    const colorRGB = colorHex
      .replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b) => '#' + r + r + g + g + b + b)
      .substring(1)
      .match(/.{2}/g)
      .map((x) => parseInt(x, 16));

    const luma = colorRGB.length ? 0.2126 * colorRGB[0] + 0.7152 * colorRGB[1] + 0.0722 * colorRGB[2] : null; // per ITU-R BT.709

    return luma >= 230 ? true : false;
  }

  setMetaDescription(shopName) {
    this.translateService.selectTranslate('general.meta_description').subscribe((text) => {
      const description = text.replace(/{{shopName}}/g, shopName);
      this.meta.addTag({ name: 'description', content: description });
    });
  }

  encodeQueryData(data) {
    const params = [];
    for (const d in data) {
      if (Object.prototype.hasOwnProperty.call(data, d)) {
        params.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
      }
    }
    return params.join('&');
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
  }
}
